import React from 'react';
import PropTypes from 'prop-types';

const LoadMore = props => {
  const { visible, onClick } = props;

  if (visible) {
    return (
      <div className="pxl-margin-top-md pxl-text-center">
        <a className="load-more" onClick={onClick}>
          Load More
        </a>
      </div>
    );
  }
  return null;
};

LoadMore.propTypes = {
  onClick: PropTypes.func,
  visible: PropTypes.bool
};

export default LoadMore;
